import { asNumber, asString } from '../http/normalise';
import {
  ApiDocumentDownloadRow,
  ApiDocumentDownloads,
} from './document-downloads.dto';
import {
  DocumentDownloadRow,
  DocumentDownloads,
} from './document-downloads.model';

function mapDownloadRow(
  dto: ApiDocumentDownloadRow
): DocumentDownloadRow | null {
  const documentId = asString(dto.documentId);
  if (documentId === null) {
    return null;
  }

  return {
    documentId,
    title: asString(dto.title) ?? '',
    downloadCount: asNumber(dto.downloadCount) ?? 0,
    uniqueAttendees: asNumber(dto.uniqueAttendees) ?? 0,
    lastDownloadedAt: asString(dto.lastDownloadedAt),
  };
}

function isDownloadRow(
  row: DocumentDownloadRow | null
): row is DocumentDownloadRow {
  return row !== null;
}

export function mapDocumentDownloads(
  dto: ApiDocumentDownloads
): DocumentDownloads {
  const rows = (dto.mostDownloaded ?? [])
    .map(mapDownloadRow)
    .filter(isDownloadRow);

  return {
    eventId: asString(dto.eventId) ?? '',
    totalDownloads: asNumber(dto.totalDownloads) ?? 0,
    rows,
  };
}
